import React from 'react'
import { ThemeProvider } from 'styled-components'

import GlobalStyle from '~/styled/global'

import { CustomerProvider } from '~/context/customer-context'
import { CartProvider } from '~/context/cart-context'
import { OverlayProvider } from '~/context/overlay-context'
import MenuProvider from '~/context/menu-context'

import Theme from '~/styled/theme'
import BreadcrumbProvider from '~/context/breadcrumb'

interface IProps {
  children: React.ReactNode
}

const RootElement = ({ children }: IProps) => {
  return (
    <CustomerProvider>
      <CartProvider>
        <ThemeProvider theme={Theme}>
          <GlobalStyle />
          <MenuProvider>
            <BreadcrumbProvider>
              <OverlayProvider>{children}</OverlayProvider>
            </BreadcrumbProvider>
          </MenuProvider>
        </ThemeProvider>
      </CartProvider>
    </CustomerProvider>
  )
}

export default RootElement
